import Label from "@/v2-ui/label"
import Checkbox from "@/v2-ui/checkbox"
import Select from "@/v2-ui/select"
import BulkForm from "@/v2-backoffice-client/components/bulkForm"
import { LANGUAGE_OPTIONS } from "@/v2-backoffice-client/invitation/invitation.constants"

type InvitationCreateFooterProps = {
  sendImmediately: boolean
  onSendImmediatelyChange(value: boolean): void
  language: string
  onLanguageChange(value: string): void
  hasValidRows: boolean
}

function InvitationCreateFooter(props: InvitationCreateFooterProps) {
  const {
    sendImmediately,
    onSendImmediatelyChange,
    language,
    onLanguageChange,
    hasValidRows,
  } = props

  return (
    <BulkForm.Footer>
      <div className="flex items-center gap-6">
        <Label className="flex items-center gap-2 text-sm cursor-pointer whitespace-nowrap text-muted-foreground">
          <Checkbox
            checked={sendImmediately}
            onCheckedChange={(checked) => {
              onSendImmediatelyChange(checked === true)
            }}
          />
          Send invitation emails immediately
        </Label>

        <div
          className="flex items-center gap-2 text-sm whitespace-nowrap text-muted-foreground"
          title="Used for the invitation email, the sign-up screen, and as the new user's initial app language."
        >
          Language
          <Select value={language} onValueChange={onLanguageChange}>
            <Select.Trigger size="xs" className="min-w-[120px]">
              <Select.Value />
            </Select.Trigger>
            <Select.Content>
              {LANGUAGE_OPTIONS.map((opt) => (
                <Select.Item key={opt.value} value={opt.value}>
                  {opt.label}
                </Select.Item>
              ))}
            </Select.Content>
          </Select>
        </div>
      </div>

      {!hasValidRows && (
        <span className="bulk-form-warning">
          Add at least one email address
        </span>
      )}
    </BulkForm.Footer>
  )
}

export default InvitationCreateFooter
